// recovery-ticket-attempt-cleanup.ts
//
// Orchestrator recovery (3.40.0, D2.5): a failed materialize try is cleaned
// BEFORE its `failed` result is journaled, so no orphan file is left for the
// next run's bootstrap commit to sweep in. The commit helper already ran
// `git add` before a policy denial, so the index holds the new bytes:
// `git reset -q -- <paths>`, then per path restore HEAD's version or delete
// it when HEAD has none. ONLY the paths the materializer wrote — a worker's
// own changes are left to resetWorktreeAfterNonDoneRoute.
//
// Security audit L-6: a delete goes only through real directories
// (ensureRealControllerDir) — a symlinked `.avatar/tickets` would aim it
// outside the worktree. Such a path is left alone; the next reset removes it.
import { rm } from "node:fs/promises";
import { dirname, join } from "node:path";
import type { GitRunner } from "./commit-owner.js";
import { ensureRealControllerDir } from "./controller-worktree-safe-file-write.js";

export async function discardRecoveryAttemptFiles(
  gitRunner: GitRunner,
  repoDir: string,
  paths: readonly string[],
): Promise<void> {
  await gitRunner(["reset", "-q", "--", ...paths], repoDir);
  for (const path of paths) {
    const inHead = await gitRunner(["cat-file", "-e", `HEAD:${path}`], repoDir);
    if (inHead.status === 0) {
      await gitRunner(["checkout", "HEAD", "--", path], repoDir);
    } else {
      const realDir = await ensureRealControllerDir(repoDir, dirname(path)).catch(() => undefined);
      if (realDir !== undefined) await rm(join(repoDir, path), { force: true });
    }
  }
}
